<div class="delegate-container">
  <!-- Approval Pending Message -->
  <div *ngIf="hasPendingRequest" class="approval-pending-card">
    <div class="approval-pending-content">
      <div class="approval-icon">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" fill="#00D084"/>
          <path d="M12 2C8.13 2 4.78 4.24 3.05 7.5L12 12L20.95 7.5C19.22 4.24 15.87 2 12 2Z" fill="#ffffff" opacity="0.2"/>
          <path d="M3.05 16.5C4.78 19.76 8.13 22 12 22C15.87 22 19.22 19.76 20.95 16.5L12 12L3.05 16.5Z" fill="#ffffff" opacity="0.2"/>
          <path d="M2 12H22" stroke="#ffffff" stroke-width="1.5" opacity="0.3"/>
        </svg>
      </div>
      <div class="approval-text">
        <h2 class="approval-title">Awaiting Approval</h2>
        <p class="approval-message">Your membership request is awaiting approval from Administrator</p>
      </div>
    </div>
  </div>

  <!-- Tabs and Content -->
  <div *ngIf="!hasPendingRequest" class="delegate-content">
    <!-- Tabs and Create Button -->
    <div class="delegate-header">
      <div class="delegate-tabs">
        <button
          class="delegate-tab"
          [class.active]="activeTab === 'delegates'"
          (click)="setActiveTab('delegates')"
          type="button"
        >
          List of Delegates
        </button>
        <button
          class="delegate-tab"
          [class.active]="activeTab === 'owners'"
          (click)="setActiveTab('owners')"
          type="button"
        >
          List of Owners
        </button>
      </div>
      
      <!-- Create New Delegate Button -->
      <button
        *ngIf="activeTab === 'delegates'"
        class="btn-create-delegate"
        (click)="onCreateNewDelegate()"
        type="button"
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path d="M12 5v14M5 12h14" stroke-width="2" stroke-linecap="round"/>
        </svg>
        <span>Create New Delegate</span>
      </button>
    </div>

    <!-- Tab Content: Delegates -->
    <div *ngIf="activeTab === 'delegates'" class="delegate-table-wrapper">
      <app-table
        [columns]="delegateColumns"
        [data]="delegatesData"
        [scrollHeight]="'500px'"
        [loading]="loading"
        [pagination]="delegatePagination"
        [emptyMessage]="delegateEmptyMessage"
        [striped]="true"
        [bordered]="true"
        [hoverable]="true"
        (pageChange)="onDelegatePageChange($event)"
        (pageSizeChange)="onDelegatePageSizeChange($event)"
        (sortChange)="onDelegateSortChange($event)"
      >
        <!-- Custom Action Column for Delegates -->
        <ng-template #delegateActionCell let-row>
          <div class="action-cell-wrapper">
            <button 
              class="action-btn" 
              (click)="toggleDelegateActionDropdown($event, row)"
              [class.active]="isDelegateDropdownOpen(row)"
              type="button"
            >
              <span>Action</span>
            </button>
            
            <!-- Dropdown Menu -->
            <div 
              class="action-dropdown-menu" 
              *ngIf="isDelegateDropdownOpen(row)" 
              [attr.data-delegate-dropdown-id]="row.id"
              (click)="$event.stopPropagation()"
            >
              <ul class="dropdown-list">
                <li class="dropdown-item">
                  <button class="dropdown-link dropdown-link--danger" (click)="handleDelegateAction('delete', row)">
                    Delete
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </ng-template>
      </app-table>
    </div>

    <!-- Tab Content: Owners -->
    <div *ngIf="activeTab === 'owners'" class="delegate-table-wrapper">
      <app-table
        [columns]="ownerColumns"
        [data]="ownersData"
        [scrollHeight]="'500px'"
        [loading]="loading"
        [pagination]="ownerPagination"
        [emptyMessage]="ownerEmptyMessage"
        [striped]="true"
        [bordered]="true"
        [hoverable]="true"
        (pageChange)="onOwnerPageChange($event)"
        (pageSizeChange)="onOwnerPageSizeChange($event)"
        (sortChange)="onOwnerSortChange($event)"
      >
        <!-- Custom Action Column for Owners -->
        <ng-template #ownerActionCell let-row>
          <div class="action-cell-wrapper">
            <button 
              class="action-btn" 
              (click)="toggleOwnerActionDropdown($event, row)"
              [class.active]="isOwnerDropdownOpen(row)"
              type="button"
            >
              <span>Action</span>
            </button>
            
            <!-- Dropdown Menu -->
            <div 
              class="action-dropdown-menu" 
              *ngIf="isOwnerDropdownOpen(row)" 
              [attr.data-owner-dropdown-id]="row.id"
              (click)="$event.stopPropagation()"
            >
              <ul class="dropdown-list">
                <li class="dropdown-item">
                  <button class="dropdown-link dropdown-link--danger" (click)="handleOwnerAction('withdraw', row)">
                    Withdraw
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </ng-template>
      </app-table>
    </div>
  </div>

  <!-- Create New Delegate Modal -->
  <app-modal
    [(visible)]="showCreateDelegateModal"
    header="Create New Delegate"
    [width]="'600px'"
    [showFooter]="true"
    [confirmLabel]="'Create Delegate'"
    [cancelLabel]="'Cancel'"
    [confirmButtonDisabled]="!isCreateDelegateFormValid"
    (onConfirm)="onSubmitCreateDelegate()"
    (onCancel)="onCloseCreateDelegateModal()"
    (visibleChange)="showCreateDelegateModal = $event"
  >
    <div class="create-delegate-modal-content">
      <!-- Leaf Pattern Decoration -->
      <div class="create-delegate-leaf-pattern">
        <img src="/assets-leaf.png" alt="" class="create-delegate-leaf-image" />
      </div>

      <!-- Form Fields -->
      <div class="create-delegate-form">
        <!-- Delegate Name -->
        <div class="create-delegate-field">
          <label class="create-delegate-label">
            Delegate Name <span class="required">*</span>
          </label>
          <input
            type="text"
            class="create-delegate-input"
            [(ngModel)]="newDelegateForm.delegateName"
            placeholder="Enter delegate name"
            maxlength="200"
          />
        </div>

        <!-- Delegate Email -->
        <div class="create-delegate-field">
          <label class="create-delegate-label">
            E-Mail <span class="required">*</span>
          </label>
          <input
            type="email"
            class="create-delegate-input"
            [(ngModel)]="newDelegateForm.delegateEmail"
            placeholder="Enter delegate email address"
            maxlength="200"
          />
        </div>
      </div>
    </div>
  </app-modal>
</div>

